import React, {useState} from "react";
// import Accordion from "../../../components/accordion/Accordion";
import {cleanDrops} from "../../hooks/helpers";
import EncabezadoHome from "./components/encabezado/EncabezadoHome";
import ElementosHome from "./components/elementos/ElementosHome";
import HomeProvider from "../../context/HomeProvider";
// import ElementosHome from "../components/elementos/ElementosHome";

function HomePage({theme}) {
   const [status, setStatus] = useState([0, 1]);

   const changeMode = (newVal, key) => {
      let nStatus = cleanDrops(status.length, key, newVal);
      setStatus([...nStatus]);
   };

   return (
      <>
         <EncabezadoHome theme={theme} status={status[0]} changeMode={changeMode} />
         <ElementosHome theme={theme} status={status[1]} changeMode={val => changeMode(val, 1)} />
      </>
   );
}

const HomeView = ({theme}) => {
   return (
      <HomeProvider>
         <HomePage theme={theme} />
      </HomeProvider>
   );
};

export default HomeView;
